exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, " .WishListIcon-iconContainer-365H5 {\r\n\tposition: absolute;\r\n    right: 26px;\r\n    top: 30px;\r\n\tz-index: 2;\r\n    cursor: pointer;\r\n}\r\n\r\n.WishListIcon-displayFlex-3BDVB {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n}\r\n\r\n.WishListIcon-marginRight-1EoJ7 {\r\n    margin-right: 30px;\r\n}\r\n\r\n.WishListIcon-minWidth-2viqZ{\r\n    min-width: 91px;\r\n}", ""]);

// exports
exports.locals = {
	"iconContainer": "WishListIcon-iconContainer-365H5",
	"displayFlex": "WishListIcon-displayFlex-3BDVB",
	"marginRight": "WishListIcon-marginRight-1EoJ7",
	"minWidth": "WishListIcon-minWidth-2viqZ"
};